import { render, staticRenderFns } from "./PagesOrdersNewOrder.vue?vue&type=template&id=a130e89a&scoped=true&"
import script from "./PagesOrdersNewOrder.vue?vue&type=script&lang=js&"
export * from "./PagesOrdersNewOrder.vue?vue&type=script&lang=js&"
import style0 from "./PagesOrdersNewOrder.vue?vue&type=style&index=0&id=a130e89a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a130e89a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VInput } from 'vuetify/lib/components/VInput';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDialog,VForm,VIcon,VInput,VTextField})
